(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["timer"] && !Shopify.designMode) return;
  try {
    
  class CountdownTimerBar extends HTMLElement {
      constructor() {
          super();
      }

      init() {
          this.schemaTime = this.getAttribute('schema-time');

          this.timer = this.querySelector(".timer")
          this.countdown = new Date(this.schemaTime).getTime();
          this.second = 1000;
          this.minute = this.second * 60;
          this.hour = this.minute * 60;
          this.day = this.hour * 24;

          this.timerInterval = null;
          this.startTimer();

          setTimeout(() => this.timer.style.visibility = "visible", 1000)
      }

      padWithLeadingZero = (number) => {
          if (number < 10) {
              return '0' + number;
          } else {
              return number;
          }
      };

      isDateInPast(date) {
          const now = new Date();
          return date < now;
      }


      startTimer() {
          //Have quick check to see if Date input in the countdown class variable is in the past
          //Helper function

          const timerElem = this.timer
          this.timerInterval = setInterval(() => {
              const now = new Date().getTime();
              const distance = this.countdown - now;

              const dayCalc = Math.floor(distance / this.day);
              const hourCalc = Math.floor((distance % this.day) / this.hour);
              const minuteCalc = Math.floor((distance % this.hour) / this.minute);
              const secondCalc = Math.floor((distance % this.minute) / this.second);

              timerElem.querySelector('.js-timer-days').textContent = this.padWithLeadingZero(dayCalc);
              timerElem.querySelector('.js-timer-hours').textContent = this.padWithLeadingZero(hourCalc);
              timerElem.querySelector('.js-timer-minutes').textContent = this.padWithLeadingZero(minuteCalc);
              timerElem.querySelector('.js-timer-seconds').textContent = this.padWithLeadingZero(secondCalc);
          }, this.second);
      }

      disconnectedCallback() {
          clearInterval(this.timerInterval);
      }

      connectedCallback(){
          this.init();
          console.log("countdown timer was added to the page")

          const timerFlexContainer = window.document.querySelector(".timer-flex-container")
          const timerElem = this.timer

          const pastDate = this.isDateInPast(this.countdown)
          if(pastDate){
              timerFlexContainer.remove()
              this.remove()
          }
          window.setTimeout(() => {
              timerFlexContainer.classList.remove("hide-element")
          }, 2000);
      }

      disconnectedCallback(){
          console.log("The Timer date has passed so the timer was removed")
      }
  }

  customElements.define('countdown-timer-bar', CountdownTimerBar);

  } catch(e) { console.error(e); }
})();
})();
